import axios from 'axios'
import {
  isEmpty
} from '@/js/util'
import util from '../../util/util'

let instance = axios.create({
  baseURL: process.env.VUE_APP_CLIENT_SERVER_URL
})

function request (options) {
  options = setToken(options)
  return new Promise((resolve, reject) => {
    instance(options)
      .then(function (response) {
        resolve(response.data)
      })
      .catch(function (error) {
        reject(error)
      })
  })
}

function setToken (options) {
  let userInfo = util.getToken()
  let baseHeader = {}

  if (userInfo && !isEmpty(userInfo.accessToken)) {
    baseHeader = {
      'X-Token': userInfo.accessToken
    }
    options['headers'] = baseHeader
  }
  return options
}

function getParamsUrl (options) {
  let result = '?'
  for (let key in options) {
    if (options[key].toString() === '[object Object]') {
      result += key + '=' + JSON.stringify(options[key])
      continue
    }
    if (options[key] || options[key] === 0) {
      result += (key + '=' + options[key] + '&')
    } else {
      result += (key + '=&')
    }
  }
  if (result[result.length - 1] === '&') {
    result = result.substring(0, result.length - 1)
  }
  return result
}

export function reqPMCode (options) {
  return request({
    method: 'get',
    url: 'public/eddidBullions/getCode' + getParamsUrl(options),
    data: options || {}
  })
}

export function reqVerifyCode (options) {
  return request({
    method: 'get',
    url: 'public/eddidBullions' + getParamsUrl(options),
    data: options || {}
  })
}

export function reqResetPwd (options) {
  return request({
    method: 'post',
    url: 'public/eddidBullions',
    data: options || {}
  })
}

export function reqResetSuccess (options) {
  return request({
    method: 'put',
    url: 'public/eddidBullions/resetSuccess' + getParamsUrl(options),
    data: options || {}
  })
}
export function reqAgreementStatus (options) {
  return request({
    method: 'get',
    url: '/public/openingAgreements' + getParamsUrl(options),
    data: options || {}
  })
}
export function reqUpdateAgreementStatus (options) {
  return request({
    method: 'put',
    url: '/public/openingAgreements/update' + getParamsUrl(options),
    data: options || {}
  })
}
